import * as React from "react"
import { cn } from "../../lib/utils"
import { inputVariants } from "./input"
import type { VariantProps } from "class-variance-authority"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof inputVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, ...props }, ref) => (
    <textarea ref={ref} className={cn(inputVariants({ variant }), "resize-none", className)} {...props} />
  )
)
Textarea.displayName = "Textarea"

export { Textarea }
